/** PWA do operador (mesmo origin) captura o link público do Web Chat. */

export function isAndroidUa(ua = typeof navigator !== "undefined" ? navigator.userAgent : "") {
  return /android/i.test(String(ua || ""));
}

export function isIosUa(ua = typeof navigator !== "undefined" ? navigator.userAgent : "") {
  return /iPad|iPhone|iPod/.test(String(ua || ""));
}

export function isWebchatStandaloneDisplay(win = typeof window !== "undefined" ? window : null) {
  if (!win) return false;
  const mq = win.matchMedia?.("(display-mode: standalone)")?.matches;
  const ios = win.navigator?.standalone === true;
  return Boolean(mq || ios);
}

function splitHttpsUrl(httpsUrl) {
  const u = new URL(String(httpsUrl || ""));
  if (u.protocol !== "https:" && u.protocol !== "http:") return null;
  return {
    hostPath: `${u.host}${u.pathname}${u.search}${u.hash}`,
    scheme: u.protocol.replace(":", ""),
    href: u.toString(),
  };
}

/**
 * Intent ACTION_VIEW fora do PWA. Sem package abre o navegador padrão
 * (Chrome, Samsung Internet…). Com chromeOnly tenta o Chrome.
 */
export function buildAndroidViewIntentUrl(httpsUrl, { chromeOnly = false } = {}) {
  try {
    const parts = splitHttpsUrl(httpsUrl);
    if (!parts) return null;
    const fallback = encodeURIComponent(parts.href);
    const pkg = chromeOnly ? "package=com.android.chrome;" : "";
    return `intent://${parts.hostPath}#Intent;scheme=${parts.scheme};action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;${pkg}S.browser_fallback_url=${fallback};end`;
  } catch {
    return null;
  }
}

/** Força o Chrome no Android, fora do PWA instalado. */
export function buildChromeIntentUrl(httpsUrl) {
  return buildAndroidViewIntentUrl(httpsUrl, { chromeOnly: true });
}

export function resolveWebchatBrowserOpenUrl(httpsUrl, ua) {
  if (isAndroidUa(ua)) {
    return buildAndroidViewIntentUrl(httpsUrl) || httpsUrl;
  }
  return httpsUrl;
}
